import { render, staticRenderFns } from "./data-category-boxes.vue?vue&type=template&id=c252d3aa&scoped=true"
import script from "./data-category-boxes.vue?vue&type=script&lang=js"
export * from "./data-category-boxes.vue?vue&type=script&lang=js"
import style0 from "./data-category-boxes.vue?vue&type=style&index=0&id=c252d3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252d3aa",
  null
  
)

export default component.exports